import { Button, Flex, useToasts } from '@applyboard/crystal-ui';
import { EmailFillIcon } from '@applyboard/ui-icons';
import { useCurrentUser, useEventTracker } from '@applyboard/ui-utils';
import { RawTestVoucher, useSendVoucherByEmail } from '../../data/testVouchers';
import { SendWhatsappDialog } from './SendWhatsappDialog';
import normalizeVoucherType from './normalizeVoucherType';

interface VoucherActionsProps {
  voucher: RawTestVoucher;
  disabled?: boolean;
}

function VoucherActions({ voucher, disabled }: VoucherActionsProps) {
  const toast = useToasts();
  const { sendVoucherByEmail, isSendingVoucherByEmail } = useSendVoucherByEmail();
  const [currentUser] = useCurrentUser();
  const { trackEvent } = useEventTracker();

  return (
    <Flex direction="row" gap={2}>
      <SendWhatsappDialog
        disabled={disabled}
        voucherId={voucher.id}
        voucherType={voucher.attributes.type}
        studentId={voucher.attributes.student_id ?? ''}
      />
      <Button
        aria-label="email"
        intent="secondary"
        emphasis="transparent"
        disabled={disabled}
        loading={isSendingVoucherByEmail}
        leadIcon={EmailFillIcon}
        onClick={() =>
          sendVoucherByEmail(
            voucher.id,
            () => {
              toast.positive('Successfully sent voucher by email.');
              trackEvent({
                event: 'VAS - Vas Hub Page - Voucher Management - Voucher sent by email',
                data: {
                  rp_id: currentUser?.id,
                  voucher_type: normalizeVoucherType(voucher.attributes.type),
                  student_id: voucher.attributes.student_id,
                },
              });
            },
            error => {
              console.error('Failed to send voucher by email', error);
              toast.negative(new Error('Failed to send voucher by email'));
            },
          )
        }
      />
    </Flex>
  );
}

export default VoucherActions;
